import { defineComponent as _defineComponent } from 'vue'
import paperOptions from '@/utils/format-edit/atenaPaperOptions.json'


export default /*#__PURE__*/_defineComponent({
  __name: 'AtenaPaperSelectCard',
  props: {
    selectedPaper: null
  },
  emits: ["select"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'select', id: string): void
}), expose: any, slots: any, attrs: any }) {





return { __sfc: true,emit, paperOptions }
}

})